import HistoryIcon from '@mui/icons-material/History';
import { Button, Card, CardContent, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { useState } from 'react';
import { FieldView } from 'src/pages/sistema/components/FieldView';
import { OperacionLCLSCuentaVista } from '../types/dto';
import { OperacionLCLSCuentaFields } from '../types/fields';
import { OperacionLCLS } from '../types/types';
import { LimitCellLayout, OperacionLCLSLimiteFila } from './OperacionLCLSLimiteFila';

interface CuentaLimitesCardProps {
  cuenta: OperacionLCLSCuentaVista;
  operacion: OperacionLCLS;
  loadLimitesOptions: () => Promise<any[]>;
  refetch: () => void;
  permiteEditar: boolean;
}


export const CuentaLimitesCard = ({ cuenta, operacion, loadLimitesOptions, refetch, permiteEditar=false }: CuentaLimitesCardProps) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const todasLasFilas = cuenta.limites || [];
  const filaActual = todasLasFilas[todasLasFilas.length - 1];
  const filasHistorial = todasLasFilas.slice(0, -1);

  const tieneHistorial = filasHistorial.length > 0;

  return (
    <Card variant="outlined" sx={{ mb: 3, boxShadow: 1 }}>
      <CardContent>
        <Grid container spacing={2} sx={{ mb: 2, mt: 2 }}>
          <Grid item xs={6} sm={4} md={2.4}>
            <FieldView label='Número de Cuenta' value={cuenta[OperacionLCLSCuentaFields.NroCuenta]} />
          </Grid>
          <Grid item xs={12} md={2.4}>
            <FieldView label='Razón Social' value={cuenta[OperacionLCLSCuentaFields.RazonSocial]} />
          </Grid>
          <Grid item xs={6} sm={4} md={2.4}>
            <FieldView label='Tipo Cliente' value={cuenta[OperacionLCLSCuentaFields.DescClienteTipo]} />
          </Grid>
          <Grid item xs={6} sm={4} md={2.4}>
            <FieldView label='Sub-tipo de Cliente' value={cuenta[OperacionLCLSCuentaFields.DescClienteSubTipo]} />
          </Grid>
          <Grid item xs={6} sm={4} md={2.4}>
            <FieldView label='Moneda' value={cuenta[OperacionLCLSCuentaFields.Moneda]} />
          </Grid>
        </Grid>

        {/* {tieneHistorial && (
          <Button
            size="small"
            startIcon={<HistoryIcon />}
            onClick={() => setIsExpanded(!isExpanded)}
            sx={{ textTransform: 'none', mb: 2 }}
            variant="outlined"
          >
            {isExpanded ? 'Ocultar Historial' : 'Ver Historial'}
          </Button>
        )} */}

        <TableContainer component={Paper}>
          <Table stickyHeader size="small">
            <TableHead>
              <TableRow sx={{ '& .MuiTypography-root': { fontSize: '0.7rem' } }}>
                <TableCell variant="head"><Typography variant="body2">Participante</Typography></TableCell>

                <TableCell variant="head" align="right">
                  <LimitCellLayout><Typography variant="body2">Límite de concertación</Typography></LimitCellLayout>
                </TableCell>
                <TableCell variant="head" align="right">
                  <LimitCellLayout><Typography variant="body2">Límite de liquidación DVP</Typography></LimitCellLayout>
                </TableCell>
                <TableCell variant="head" align="right">
                  <LimitCellLayout><Typography variant="body2">Límite de liquidación FOP</Typography></LimitCellLayout>
                </TableCell>

                <TableCell variant="head"><Typography variant="body2">Fecha de la acción</Typography></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>

              {/* {filasHistorial.map((limite) => (
                <OperacionLCLSLimiteFila
                  key={limite.id}
                  operacion={operacion}
                  limite={limite}
                  loadLimitesOptions={loadLimitesOptions}
                  refetch={refetch}
                  isHistoryRow={true}
                  isExpanded={isExpanded}
                />
              ))} */}

              {filaActual && <OperacionLCLSLimiteFila key={filaActual.id} operacion={operacion} limite={filaActual} loadLimitesOptions={loadLimitesOptions} refetch={refetch} permiteEditar={permiteEditar}/>}
            </TableBody>
          </Table>
        </TableContainer>
      </CardContent>
    </Card>
  );
};